import $ from 'jquery';

(() => {
  const $rows = $('.Agenda-row');
  if (!$rows.length) return;

  const $tabs = $('.tab');
  const $btnProducts = $('.Filter--products');
  const $btnAudience = $('.Filter--audience');
  const $btnTopics = $('.Filter--topics');
  const $btns = $('.Filter');
  const $filterGroup = $('.Filter--group');

  /* eslint-disable */
  $.fn.extend({
    strip: function () {
      return $(this).text().toLowerCase().trim();
    }
  });
  /* eslint-enable */

  function rowHasActiveFilter($row, types = 'product') {
    const type = types; // product | topic | audience

    const $filterResult = (type === 'product') ? $btnProducts : (type === 'topic') ? $btnTopics : $btnAudience;
    const $labels = $row.find(`.Agenda-row-${type}`);
    const $activeLabels = [];
    let hasActiveLabel = false;
    $filterResult.filter('.is-active').each((al, activeLabel) => {
      const $activeLabel = $(activeLabel);
      $activeLabels.push($activeLabel.strip());
    });

    if ($activeLabels.length) {
      $labels.each((l, label) => {
        if (jQuery.inArray($(label).strip(), $activeLabels) > -1) {
          hasActiveLabel = true;
        }
      });
    }
    else {
      hasActiveLabel = true;
    }

    return hasActiveLabel;
  }

  function calcCount() {
    let num = 0;
    let tid = '';
    $('.Agenda').each((i, agenda) => {
      num = $(agenda).find('.Agenda-row:not(.is-filtered)').length;
      tid = $(agenda).attr('id');
      const $sel = $(`.tab[href="#${tid}"]`).find('.counter');
      $sel.removeClass('is-active-empty');
      $sel.addClass('is-active').html(num);
      if (num === 0) $sel.addClass('is-active-empty');
      setTimeout(() => {
        $('.tab .counter.is-active').removeClass('is-active');
      }, 450);
    });
  }

  function replaceHistory(hash = '') {
    let urlHash = hash === null ? '' : hash;
    if (urlHash.length < 1) {
      if (window.history.pushState) {
        window.history.pushState('', document.title, ' ');
      }
      else {
        window.location.hash = '';
      }
      return;
    }

    urlHash = new RegExp('#').test(urlHash) ? urlHash : `#${urlHash}`;
    if (window.history.replaceState) {
      window.history.replaceState('', document.title, urlHash);
    }
    else {
      window.location.replace(urlHash);
    }
  }

  function markLastInGroup() {
    $('.last-in-group').removeClass('last-in-group');

    $('.Agenda-general-session-row').each((i, row) => {
      let generals = $(row).nextUntil('.Agenda-announcement-break-row, .Agenda-panel-discussion-row');
      generals = generals.filter(() => !$(row).hasClass('is-filtered'));
      generals.last().addClass('last-in-group');
    });

    $('.Agenda-breakout-session-row').each((i, row) => {
      let breakouts = $(row).nextUntil('.Agenda-announcement-break-row, .Agenda-panel-discussion-row');
      breakouts = breakouts.filter(() => !$(row).hasClass('is-filtered'));
      breakouts.last().addClass('last-in-group');
    });
  }

  function filterRows() {
    const $this = $(this);

    if ($this.hasClass('Filter--topics')) {
      $btnProducts.removeClass('is-active');
    }

    if ($this.hasClass('Filter--products')) {
      $btnTopics.removeClass('is-active');
    }

    if ($this.hasClass('Filter--audience')) {
      $this.siblings().removeClass('is-active');
    }

    $this.toggleClass('is-active');

    let visibleRows = 0;
    $rows.each((i, row) => {
      const $row = $(row);
      if (rowHasActiveFilter($row, 'product') && rowHasActiveFilter($row, 'topic') && rowHasActiveFilter($row, 'audience')) {
        visibleRows = 1 + visibleRows;
        $row.removeClass('is-filtered').stop(true, true).slideDown(200);
      }
      else {
        $row.addClass('is-filtered').stop(true, true).slideUp(200);
      }
      if ($('.Filter--products.is-active').length) {
        $('.general-group').removeClass('is-filtered').stop(true, true).slideDown(200);
      }
    });

    setTimeout(calcCount, 300);

    let q = '#filters';
    $btns.filter('.is-active').each((fl, checked) => {
      q += `-${$(checked).strip()}`;
    });
    if ($btns.filter('.is-active').length === 0) {
      replaceHistory(null);
    }
    if (q !== '#filters') {
      q = q.replace(/\s/g, '_');
      replaceHistory(q);
    }

    markLastInGroup();
  }

  function selectFilter(filterName) {
    $btns.each((i, btn) => {
      if ($(btn).strip() === filterName) {
        $(btn).addClass('is-active');
      }
    });
  }

  function readHash() {
    let {
      location: {
        hash: urlHash
      }
    } = document;
    if (!urlHash.length) return;

    $btns.removeClass('is-active');
    urlHash = urlHash.replace('#filters', '').replace(/_/g, ' ').split('-').slice(1);
    $(urlHash).each((i, h) => {
      selectFilter(h);
    });
    filterRows();
  }

  function toggleExpand() {
    $(this).toggleClass('is-visible-group').next().toggleClass('is-visible');
  }

  function groupSessions() {
    $('.Agenda-general-session-row').each((i, row) => {
      $(row).nextUntil('.Agenda-announcement-break-row, .Agenda-panel-discussion-row, .Agenda-breakout-session-row').addClass('general-group');
    });

    $('.Agenda-breakout-session-row').each((i, row) => {
      $(row).nextUntil('.Agenda-announcement-break-row, .Agenda-panel-discussion-row, .Agenda-general-session-row').addClass('breakout-group');
    });

    $('.Agenda-panel-discussion-row').each((i, row) => {
      $(row).nextUntil('.Agenda-announcement-break-row, .Agenda-general-session-row, .Agenda-breakout-session-row').addClass('panel-group');
    });
  }

  function tabClick(e) {
    e.preventDefault();
    $(this).addClass('is-active').siblings().removeClass('is-active');
    $('.Agenda').hide();
    $(this.hash).show();
  }

  function init() {
    $filterGroup.on('click', toggleExpand);
    $btns.on('click', filterRows);
    $tabs.on('click', tabClick);

    readHash();
    calcCount();
    groupSessions();
    markLastInGroup();
  }

  $(document).ready(init);
})();
